<template>
  <div class="emails">
    <ba-header activeModule="Insured Messages"></ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">Send A Message</h2>
      <div class="u-text--light">This message will be sent to the user:</div>
      <div v-if="insured" class="receiver u-pl3 u-mt4">
        <div class="u-mt2">{{insured.name}} <span class="u-text--light u-text--sm u-ml5">{{insured.username}}</span>
        </div>
      </div>

      <ba-send-insured-message v-loading="loading" :message-audience="'insured'" :companyId="companyId"
                               :insured-id="insuredId"/>
    </div>
  </div>

</template>

<script>
  import BaNewInsuredMessageForm from '@/modules/messages/send-insured-message.component'
  import {mapActions, mapState} from 'vuex'

  export default {
    components: {
      'ba-send-insured-message': BaNewInsuredMessageForm,
    },
    name: 'ba-send-single-insured-message',
    data () {
      return {
        companyId: this.$route.params.companyId,
        loading: false,
      }
    },
    async mounted () {
      if (!this.users) {
        this.loading = true
        await this.getAllInsureds(this.companyId)
        this.loading = false
      }
    },
    methods: {
      ...mapActions('shared', ['getAllInsureds']),
    },
    computed: {
      ...mapState('shared', ['users']),
      insured () {
        if (!this.users) {
          return
        }
        let insured = this.users[this.insuredId]
        if (!insured) {
          return
        }

        return insured
      },
      insuredId () {
        return this.$route.query.insuredId
      },
    },
  }
</script>

